<template>
  <template-layout>
    <div class="py-12 px-4">
      <nav class="flex justify-between items-center mb-4">
        <h1 class="text-2xl text-theme-1">
          อพม.
        </h1>
        <AddVolunteerModal :addVolunteerModal="addVolunteerModal" @modal-value="clearValue"/>
        <button class="btn md:btn-lg btn-primary mr-1 mb-2" @click="openAddVolunteerModal(true)" data-test="button-add-volunteer-moal">
          <span xs:text-sm md:text-base>+ เพิ่ม อพม.</span>
        </button>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-4 lg:col-span-3">
          <VolunteerFilter />
        </div>
        <div class="col-span-12 md:col-span-8 lg:col-span-9">
          <FilterSummary :items="filterSummaryStore"/> 
          <VolunteerDatatable :reload-table="reloadTable" />
        </div>
      </div>
    </div>
  </template-layout>
</template>
<script setup>
import VolunteerFilter from "@/components/filter-search/VolunteerFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import VolunteerDatatable from "@/views/volunteer-datatable/index.vue"
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import AddVolunteerModal from "@/components/add-volunteer-modal/index.vue";
import { useStore } from "vuex";
import { computed, watch, ref } from "vue";


const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["volunteerFilter/getFilterSummaryArray"]
);
const addVolunteerModal = ref(false);
const reloadTable = ref(false);

const openAddVolunteerModal = (val) => {
  addVolunteerModal.value = val
  reloadTable.value = false
}     
const clearValue = (val) => {
  addVolunteerModal.value = false
  reloadTable.value = val == "saved" ? true : false
}
</script>